// components/TypeBadge.jsx

const typeLabels = {
    service: "Service",
    job: "Steps",
    checklist: "Checklist Items",
    steps: "Steps",
};

// Colores por tipo
const typeColors = {
    service: "bg-blue-100 text-gray-800",
    job: "bg-teal-100 text-teal-800",
    Steps: "bg-teal-100 text-teal-800",
    checklist: "bg-amber-100 text-amber-800",
};

export default function TypeBadge({ type, className = "" }) {
    const label = typeLabels[type] || type;
    const colors = typeColors[type] || "bg-gray-100 text-gray-800";

    return (
        <span
            className={`px-3 py-1 text-xl font-medium rounded-full capitalize ${colors} ${className}`}
        >
            {label}
        </span>
    );
}
